import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { updateCompany } from '../../shared/utils/api';
import { flashForReact } from '../../communities_manage/flash_react';
import CompanyFormHeader from './form/company_form_header';
import CompanyFormBody from './form/company_form_body';

const CompanyForm = ({ initCompany, optionsForLists }) => {
  const [formData, setFormdata] = useState(initCompany);
  const [isLoading, setIsLoading] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [files, setFiles] = useState([]);

  const handleSaveForm = () => {
    setIsLoading(true);

    updateCompany(formData, files, handleSuccess, handleFailure);
  };

  const handleFieldChange = e => {
    const { name, value } = e.target;
    setIsChanged(true);
    setFormdata(prevState => ({ ...prevState, [name]: value }));
  }

  const handleSuccess = () => {
    window.location.href = window.location.href.replace('/edit', '')
  }

  const handleFailure = error => {
    setIsLoading(false);
    const { errors } = error.response.data;
    flashForReact('danger', errors && errors[0] || 'Something went wrong.');
  }

  const updateFiles = data => {
    setFiles(data);
    setIsChanged(true);
  }

  return (
    <div>
      <CompanyFormHeader
        handleSaveForm={handleSaveForm}
        isLoading={isLoading}
        isChanged={isChanged}
      />
      <div className='container--extend'>
        <CompanyFormBody
          formData={formData}
          handleFieldChange={handleFieldChange}
          optionsForLists={optionsForLists}
          files={files}
          setFiles={updateFiles}
        />
      </div>
    </div>
  );
};

CompanyForm.propTypes = {
  initCompany: PropTypes.object.isRequired,
  optionsForLists: PropTypes.object.isRequired
};

export default CompanyForm;
